import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  button {
    display: flex;
    align-items: center;
    background: transparent;
    border: 0;

    font-size: 1.2rem;
    color: var(--table-color);
  }
`

interface IButton {
  selected?: boolean
}

export const Button = styled.button<IButton>`
  ${(props) =>
    props.selected &&
    css`
      && {
        color: var(--table-color-selected);
      }
    `}
`

export const ButtonASC = styled(Button)``

export const ButtonDESC = styled(Button)``
